import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { BehaviorSubject, fromEvent } from "rxjs";
import { MobileToasterService } from "./services/mobile-toaster.service";

@Component({
  selector: "mobile-toaster",
  templateUrl: "./mobile-toaster.component.html",
  styleUrl: "./mobile-toaster.component.scss",
  standalone: true,
  imports: [CommonModule]
})
export class MobileToaster implements OnInit {
  appear = false;

  toasters: Toaster[] = [];

  MobileToaster$!: BehaviorSubject<Toaster>;

  constructor(
    private _mobileToaster: MobileToasterService
  ) {
    this.MobileToaster$ = _mobileToaster.MobileToaster$;
  }

  ngOnInit(): void {
    this.MobileToaster$.subscribe(
      toast => {
        if (toast.detail) {
          this.toasters.push({
            ...toast,
            bar: false,
            appear: false,
          })
          this.toasters.map((ele, i) => {
            setTimeout(() => {
              ele.appear = true;
              ele.bar = true;
              setTimeout(() => {
                ele.appear = false;
                ele.bar = false;
                setTimeout(() => {
                  this.toasters.splice(i, 1);
                }, 400);
              }, 4000);
            }, Number(`${i}00`));
          })
        }
      }
    )
    // fromEvent(window, 'click').subscribe(
    //   res => {
    //     this.toasters.map( ( ele, i ) => {
    //       setTimeout(() => {
    //         ele.appear = true,
    //         ele.bar = true;
    //         setTimeout(() => {
    //           ele.appear = false,
    //           ele.bar = false;
    //         }, 4000);
    //       }, Number(`${i}00`));
    //     } )


    //     // this.asd = true;
    //     // this.appear = true;
    //     // setTimeout(() => {
    //     //   this.appear = false;
    //     //   this.asd = false;
    //     // }, 4000);
    //   }
    // )

    // fromEvent(window, 'dblclick').subscribe(
    //   res => {
    //     console.log('Double Click');
    //   }
    // )
  }

}


interface Toaster {
  severity: string,
  summary: string,
  detail: string,
  appear?: boolean,
  bar?: boolean
}